import { render } from "./ModalPager.vue?vue&type=template&id=da822502&scoped=true&ts=true"
import script from "./ModalPager.vue?vue&type=script&lang=ts"
export * from "./ModalPager.vue?vue&type=script&lang=ts"

import "./ModalPager.vue?vue&type=style&index=0&id=da822502&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da822502"]])

export default __exports__